import { render, staticRenderFns } from "./UpgradeService.vue?vue&type=template&id=586393de&scoped=true&"
import script from "./UpgradeService.vue?vue&type=script&lang=js&"
export * from "./UpgradeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586393de",
  null
  
)

export default component.exports